import * as React from 'react';
import Snackbar from '@mui/joy/Snackbar';
import { useSnackbarStore } from '../../store/useSnackbarStore';

export default function GlobalSnackbar() {
  const { open, message, severity, hideSnackbar } = useSnackbarStore();
  return (
    <Snackbar
      open={open}
      color={severity}
      variant="soft"
      autoHideDuration={3000}
      onClose={hideSnackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      {message}
    </Snackbar>
  );
}
